import { usePublishedData } from "../lib/published-data";
import { createFileRoute } from "@tanstack/react-router";
import { DocumentContent } from "../components/document-content";
import { documentHead, loadPage, useShell } from "../lib/document-route";

/** About: the creator's authored About page, or the native section built from their profile. */
export const Route = createFileRoute("/about")({
  loader: () => loadPage("/about", "native"),
  head: ({ matches, loaderData }) =>
    documentHead(matches, loaderData, "/about", {
      title: (shell) => `About ${shell.creator.name}`,
      description: (shell) => shell.creator.description,
    }),
  component: About,
});

function About() {
  const initial = Route.useLoaderData();
  const shell = useShell();
  const { data } = usePublishedData(initial, shell, "/about", "page");
  if (data.kind === "page") return <DocumentContent data={data} shell={shell} />;
  const { creator } = shell;
  return (
    <section className="section">
      <div className="container about-creator">
        <div>
          <p className="eyebrow">About</p>
          <h1>{creator.name}</h1>
          {creator.description && <p className="prose">{creator.description}</p>}
          {creator.socials.length > 0 && (
            <nav aria-label="Find the creator">
              {creator.socials.map((link) => (
                <a key={link.url} href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.label} <span aria-hidden="true">↗</span>
                </a>
              ))}
            </nav>
          )}
        </div>
        {creator.coverUrl && (
          <img className="creator-cover" src={creator.coverUrl} alt={creator.name} />
        )}
      </div>
    </section>
  );
}
